import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountryListService {

   private country_list = [
        { id: 1, country: "Australia", phoneCode: "+93" },
        { id: 2, country: "Albania", phoneCode: "+355" },
        { id: 3, country: "Algeria", phoneCode: "+213" },
        { id: 4, country: "Andorra", phoneCode: "+376" },
        { id: 5, country: "Angola", phoneCode: "+244" },
        { id: 6, country: "Brazil", phoneCode: "+55" },
        { id: 7, country: "Argentina", phoneCode: "+54" },
        { id: 8, country: "Armenia", phoneCode: "+374" },
        { id: 9, country: "Australia", phoneCode: "+61" },
        { id: 10, country: "Austria", phoneCode: "+43" },
        { id: 11, country: "Azerbaijan", phoneCode: "+994" },
        { id: 12, country: "Bulgaria", phoneCode: "+359" },
        { id: 13, country: "Bahrain", phoneCode: "+973" },
        { id: 14, country: "Bangladesh", phoneCode: "+880" },
        { id: 15, country: "Bolivia", phoneCode: "+591" },
        { id: 16, country: "Belarus", phoneCode: "+375" },
        { id: 17, country: "Belgium", phoneCode: "+32" },
        { id: 18, country: "Belize", phoneCode: "+501" },
        { id: 20, country: "UAE", phoneCode: "+971" },
        { id: 21, country: "Saudi Arabia", phoneCode: "+966" },
    ];

    private jobCreateCountries = [
      { id: 1, country: "Australia", phoneCode: "+61" },
      { id: 2, country: "UAE", phoneCode: "+971" },
      { id: 3, country: "Saudi Arabia", phoneCode: "+966" },
      { id: 4, country: "Kuwait", phoneCode: "+965" },
      { id: 5, country: "Qatar", phoneCode: "+974" },
      { id: 6, country: "Singapore", phoneCode: "+65" },
      { id: 7, country: "United Kingdom", phoneCode: "+44" }
    ];

    private jobCreateCities = [
      { id: 1, country: "Australia", city: "Sydney", phoneCode: "+61" },
      { id: 2, country: "Australia", city: "Melbourne", phoneCode: "+61" },
      { id: 3, country: "Australia", city: "Perth", phoneCode: "+61" },
      { id: 4, country: "Australia", city: "Adelaide", phoneCode: "+61" },
      { id: 5, country: "Australia", city: "Brisbane", phoneCode: "+61" },
      { id: 6, country: "Kuwait", city: "Kuwait City", phoneCode: "+965" },
      { id: 7, country: "Kuwait", city: "Al Ahmadi", phoneCode: "+965" },
      { id: 8, country: "Kuwait", city: "Hawalli", phoneCode: "+965" },
      { id: 9, country: "Kuwait", city: "Farwaniya", phoneCode: "+965" },
      { id: 10, country: "Kuwait", city: "Jahra", phoneCode: "+965" },
      { id: 11, country: "UAE", city: "Dubai", phoneCode: "+971" },
      { id: 12, country: "UAE", city: "Abu Dhabi", phoneCode: "+971" },
      { id: 13, country: "UAE", city: "Sharjah", phoneCode: "+971" },
      { id: 14, country: "UAE", city: "Ajman", phoneCode: "+971" },
      { id: 15, country: "UAE", city: "Fujairah", phoneCode: "+971" },
      { id: 16, country: "UAE", city: "Ras Al Khaimah", phoneCode: "+971" },
      { id: 17, country: "UAE", city: "Umm Al Quwain", phoneCode: "+971" },
      { id: 18, country: "Saudi Arabia", city: "Riyadh", phoneCode: "+966" },
      { id: 19, country: "Saudi Arabia", city: "Jeddah", phoneCode: "+966" },
      { id: 20, country: "Saudi Arabia", city: "Mecca", phoneCode: "+966" },
      { id: 21, country: "Saudi Arabia", city: "Medina", phoneCode: "+966" },
      { id: 22, country: "Saudi Arabia", city: "Dammam", phoneCode: "+966" },
      { id: 23, country: "Saudi Arabia", city: "Khobar", phoneCode: "+966" },
      { id: 24, country: "Saudi Arabia", city: "Tabuk", phoneCode: "+966" },
      { id: 25, country: "Qatar", city: "Doha", phoneCode: "+974" },
      { id: 26, country: "Qatar", city: "Al Rayyan", phoneCode: "+974" },
      { id: 27, country: "Qatar", city: "Al Wakrah", phoneCode: "+974" },
      { id: 28, country: "Qatar", city: "Umm Salal", phoneCode: "+974" },
      { id: 29, country: "Qatar", city: "Al Khor", phoneCode: "+974" },
      { id: 30, country: "Singapore", city: "Singapore", phoneCode: "+65" },
      { id: 31, country: "United Kingdom", city: "London", phoneCode: "+44" },
      { id: 32, country: "United Kingdom", city: "Manchester", phoneCode: "+44" },
      { id: 33, country: "United Kingdom", city: "Birmingham", phoneCode: "+44" },
      { id: 34, country: "United Kingdom", city: "Glasgow", phoneCode: "+44" },
      { id: 35, country: "United Kingdom", city: "Leeds", phoneCode: "+44" },
      { id: 36, country: "United Kingdom", city: "Liverpool", phoneCode: "+44" },
      { id: 37, country: "United Kingdom", city: "Bristol", phoneCode: "+44" },
      { id: 38, country: "Australia", city: "Canberra", phoneCode: "+61" },
      { id: 39, country: "Australia", city: "Tasmania", phoneCode: "+61" },
      { id: 40, country: "Australia", city: "Northern Territory 4", phoneCode: "+61" },
      { id: 41, country: "Australia", city: "Gold Coast", phoneCode: "+61" }
    ];

    
  constructor() { }

  getCountryList() {
    return this.country_list;
  }

  getJobCreateCountries(){
    return this.jobCreateCountries;
  }

  getJobCreateCities(){
    return this.jobCreateCities;
  }
}
